export const moduleName = 'Atheneum';
